import styled from 'styled-components';
import { Banner } from '@equinor/eds-core-react';
import { spacings } from '../../../../tokens/spacings';
import { theme } from '../../../../tokens/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacings.MEDIUM};
`;

export const CoordinateRow = styled.div`
  display: flex;
  gap: ${spacings.MEDIUM};
  flex-wrap: wrap;
`;

export const Actions = styled.div`
  display: flex;
  gap: ${spacings.SMALL};
  align-items: center;
  flex-wrap: wrap;
`;

export const Hint = styled.p`
  font-size: 12px;
  color: #6f6f6f;
  margin: 0;
`;

export const Warning = styled(Banner)`
  div {
    background-color: ${theme.light.info.warning};
  }
`;
